import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { DeviceListScene } from 'scenes';

class DeviceListContainer extends AbstractContainer {

  getTasks(params) {

    return [
      {
        key: 'devices',
        exec: (done, failure) => {
          API.get(`devices`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
    ]
  }

  getComponent(results) {
    return <DeviceListScene {...results} />
  }
}

export default DeviceListContainer;
